import React, { useState, useEffect, useMemo, useRef } from "react";

const SearchableSelect = ({ value, onChange, options = [], placeholder, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);

  const selectedLabel = options.find(o => o.value === value)?.label || "";

  const filteredOptions = useMemo(() => {
    if (!search) return options;
    const lower = search.toLowerCase();
    return options.filter(o => o.label.toLowerCase().includes(lower));
  }, [options, search]);

  // Close on outside click
  useEffect(() => {
    const handleClick = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen]);

  const handleSelect = optionValue => {
    onChange(optionValue);
    setIsOpen(false);
    setSearch("");
  };

  const handleClear = e => {
    e.stopPropagation();
    onChange("");
    setSearch("");
  };

  if (disabled) {
    return (
      <div className="form-control text-muted" style={{ cursor: "not-allowed", backgroundColor: "var(--tblr-bg-surface-secondary, #f8f9fa)" }}>
        {selectedLabel || placeholder || "-- Chọn --"}
      </div>
    );
  }

  return (
    <div ref={containerRef} style={{ position: "relative" }}>
      <div
        className="form-control d-flex align-items-center justify-content-between"
        style={{ cursor: "pointer", minHeight: 38 }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={selectedLabel ? "" : "text-muted"} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {selectedLabel || placeholder || "-- Chọn --"}
        </span>
        <span className="d-flex align-items-center gap-1">
          {value && (
            <span onClick={handleClear} style={{ padding: "0 4px", cursor: "pointer", fontSize: 16, lineHeight: 1 }}>&times;</span>
          )}
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </span>
      </div>

      {isOpen && (
        <div
          className="card"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1060,
            marginTop: 4,
            maxHeight: 240,
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          <div style={{ padding: "8px 8px 4px" }}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Tìm kiếm..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              autoFocus
            />
          </div>
          <div style={{ overflowY: "auto", flex: 1 }}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map(option => (
                <button
                  key={option.value}
                  type="button"
                  className={`dropdown-item ${option.value === value ? "active" : ""}`}
                  style={{ padding: "8px 12px", fontSize: 14 }}
                  onClick={() => handleSelect(option.value)}
                >
                  {option.label}
                </button>
              ))
            ) : (
              <div className="text-muted text-center" style={{ padding: "12px" }}>Không tìm thấy</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
